/**
 * localStorage / sessionStorage can be missing or throw (private windows, blocked cookies, quota).
 * These wrappers never throw and fall back to memory so the app still runs.
 */
function make(kind) {
  const memory = new Map();
  let backend = null;
  try {
    backend = window[kind];
    const probe = '__vc_probe__';
    backend.setItem(probe, '1');
    backend.removeItem(probe);
  } catch {
    backend = null;
  }
  return {
    get(key) {
      try {
        return backend ? backend.getItem(key) : (memory.get(key) ?? null);
      } catch {
        return memory.get(key) ?? null;
      }
    },
    set(key, value) {
      try {
        if (backend) backend.setItem(key, value);
        else memory.set(key, value);
      } catch {
        memory.set(key, value);
      }
    },
    remove(key) {
      memory.delete(key);
      try {
        backend?.removeItem(key);
      } catch {
        /* ignore */
      }
    },
    getJson(key, fallback = null) {
      const value = this.get(key);
      if (value == null) return fallback;
      try {
        return JSON.parse(value);
      } catch {
        return fallback;
      }
    },
    setJson(key, value) {
      this.set(key, JSON.stringify(value));
    },
  };
}

export const local = make('localStorage');
export const session = make('sessionStorage');
